import { computed } from 'vue';
import { isNullOrUndefined } from 'shared/lib/object/object';
import { useI18n } from 'vue-i18n';

const forgeDemoEmail = (user) => {
  const fn = (user.firstName || '').toLowerCase();
  const ln = (user.lastName || '').toLowerCase();
  return `${fn}.${ln}@example.org`;
};

export const email = (user) => {
  if (isNullOrUndefined(user)) {
    return '';
  }
  if (user.isDemo === true) {
    return forgeDemoEmail(user);
  }
  return user.identity?.email ?? '';
};

export const fullName = (user) => {
  if (isNullOrUndefined(user)) {
    return '';
  }
  return `${user.firstName} ${user.lastName}`.trim();
};

export const language = (user) => {
  if (isNullOrUndefined(user)) {
    return '';
  }
  return user.identity?.language ?? '';
};

export const displayName = (user, deletedFallback = '') => {
  if (isNullOrUndefined(user)) {
    return deletedFallback;
  }
  return fullName(user) || email(user);
};

export default function useUser(userRef) {
  const { t } = useI18n();
  return {
    email: computed(() => email(userRef.value)),
    fullName: computed(() => fullName(userRef.value)),
    displayName: computed(() => displayName(userRef.value, t('user.deleted.name'))),
    language: computed(() => language(userRef.value)),
  };
}
